const locale = {
  message: '确定要删除吗？',
  confirm: '确定',
  delete: '删除',
  cancel: '取消',
  more: '更多'
};

export default locale;
